import { IResponseState } from "../../../../../components/Modals/ResponseModal/module/constants";
import { IReportSent, IReportType } from "../../module/constants";

export interface IReportSectionProps {
  reportFormValues: any;
  changeLocation: (url: string) => void;
  reports: IReportSent[];
  responseDelete: IResponseState;
  responseAddEditState: IResponseState;
  getReports: () => void;
  delReport: (ids: string[]) => void;
  setToEditProp: (data: IReportType) => void;
  setIsEditProp: (b: boolean) => void;
  setToViewProp: (data: IReportType) => void;
  loader: boolean;
}

export const REPORT_MGMT_REPO_FORM_FILTER = "reportMgmtRepoFormFilter";

export const STATE_IDENTIFIER = {
  REPORTS: "reports",
  REPO_DEL_STATE: "deleteState",
  REPO_ADD_EDIT_STATE: "addEditState",
  IS_EDIT: "isEdit",
  TO_EDIT: "toEdit",
  ROLES: "roles",
  REPO_ROLES: "repoRoles",
  TO_VIEW: "viewReport",
  GENERATION_STATE: "generationState",
  VALUE: "value",
  GENERATED: "generated",
  LOADER_IDENTIFIER: "loader",
};
